<script setup>
import { computed } from 'vue'

// tage: [{ key, label, spalten: [{ id, name, farbe? }], eintraege: [{ id, spalteId, start: Date, ... }] }]
const props = defineProps({
  tage: { type: Array, default: () => [] },
  spaltenbreite: { type: String, default: '150px' }
})
const emit = defineEmits(['select'])

function uhrzeit(d) {
  return d.toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' })
}
function zeiten(tag) {
  return [...new Set(tag.eintraege.map(e => uhrzeit(e.start)))].sort()
}
function eintraegeAn(tag, spalteId, zeit) {
  return tag.eintraege.filter(e => e.spalteId === spalteId && uhrzeit(e.start) === zeit)
}
function spaltenMuster(tag) {
  const min = props.spaltenbreite === '1fr' ? '0' : props.spaltenbreite
  return `56px repeat(${tag.spalten.length}, minmax(${min}, 1fr))`
}
const hatSpalten = computed(() => props.tage.some(t => t.spalten.length > 0))
</script>

<template>
  <div class="tm-raster">
    <div v-if="!hatSpalten" class="tm-raster__leer">Keine Spiele an diesem Tag.</div>
    <div v-else class="tm-raster__scroll">
      <div class="tm-raster__reihe">
        <div v-for="tag in tage" :key="tag.key" class="tm-raster__tag">
          <div
            v-if="tag.spalten.length > 0"
            class="tm-raster__grid"
            :style="{ gridTemplateColumns: spaltenMuster(tag) }"
          >
            <div class="tm-raster__ecke">{{ tag.label }}</div>
            <div
              v-for="spalte in tag.spalten"
              :key="spalte.id"
              class="tm-raster__kopf"
              :style="spalte.farbe ? { '--col': spalte.farbe } : null"
            >
              <span class="tm-raster__kopf-name">{{ spalte.name }}</span>
            </div>

            <template v-for="zeit in zeiten(tag)" :key="zeit">
              <div class="tm-raster__zeit">{{ zeit }}</div>
              <div
                v-for="spalte in tag.spalten"
                :key="spalte.id + zeit"
                class="tm-raster__zelle"
                :style="spalte.farbe ? { '--col': spalte.farbe } : null"
              >
                <div
                  v-for="e in eintraegeAn(tag, spalte.id, zeit)"
                  :key="e.id"
                  :class="['tm-raster__karte', `tm-raster__karte--${e.status}`]"
                  role="button"
                  tabindex="0"
                  @click="emit('select', e)"
                  @keydown.enter="emit('select', e)"
                >
                  <div class="tm-raster__meta">
                    <span v-if="e.liga || e.flagge" class="tm-raster__liga">
                      <img v-if="e.flagge" :src="e.flagge" alt="" class="tm-raster__flagge" />
                      <span v-if="e.liga">{{ e.liga }}</span>
                    </span>
                    <span class="tm-raster__meta-rechts">
                      <span v-if="e.story" class="tm-raster__story" title="Story vorhanden">📰</span>
                      <span v-if="e.badge" class="tm-raster__badge">{{ e.badge }}</span>
                    </span>
                  </div>

                  <div class="tm-raster__team">
                    <img v-if="e.heimLogo" :src="e.heimLogo" alt="" class="tm-raster__logo" />
                    <span class="tm-raster__name">{{ e.heim ?? e.titel }}</span>
                    <span v-if="e.toreHeim != null" class="tm-raster__tor">{{ e.toreHeim }}</span>
                  </div>
                  <div v-if="e.auswaerts" class="tm-raster__team">
                    <img v-if="e.auswaertsLogo" :src="e.auswaertsLogo" alt="" class="tm-raster__logo" />
                    <span class="tm-raster__name">{{ e.auswaerts }}</span>
                    <span v-if="e.toreAus != null" class="tm-raster__tor">{{ e.toreAus }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>